module.exports = __webpack_public_path__ + "static/devfestnantes2018-21f8a459d07b005f9725365a7fcbd680.png";